export const isAtLeast15YearsOld = (user) => {
    if (!user?.profile?.birthdate)
        return true;
    const birthYear = new Date(user.profile.birthdate).getFullYear();
    const age = new Date().getFullYear() - birthYear;
    return age >= 15;
};
export const pagePermissions = {
    clubWeb: isAtLeast15YearsOld,
    s4: isAtLeast15YearsOld,
    y2c: (_user) => true,
    reg: isAtLeast15YearsOld,
};
//# sourceMappingURL=pagePermissions.js.map